module.exports = "/_next/static/images/3-34621a898a4cca461e15449142d845f0.png";